// extracted by mini-css-extract-plugin
export default {"card":"card_card__iPtAn","small_card":"card_small_card__6nJCF"};